export default "__VITE_ASSET__Bn3CzWrq__"